// src/pages/NotFound/notFound.jsx - Versão Simples
import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50 px-4">
      <div className="text-center space-y-6">
        
        {/* 404 */}
        <h1 className="text-9xl md:text-[180px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">
          404
        </h1>

        {/* Mensagem */}
        <div className="space-y-3">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
            Página Não Encontrada
          </h2>
          <p className="text-lg text-gray-600">
            Ops! Essa página não existe.
          </p>
        </div>

        {/* Botão */}
        <button
          onClick={() => navigate('/')}
          className="mt-8 px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold shadow-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 transform hover:scale-105"
        >
          Voltar para o Início
        </button>

        {/* Footer */}
        <p className="text-xs text-gray-500 pt-8">
          © {new Date().getFullYear()} CMD Automação
        </p>
      </div>
    </div>
  );
}